<script setup>
import {demoList}  from '@/apis/home'
import {onMounted, ref,reactive } from 'vue'
import {useRouter} from "vue-router";
const router = useRouter()

import mynav from './components/myNav.vue'
import myfoot from './components/myfoot.vue'
import {ElMessage} from "element-plus";
import {Search} from "@element-plus/icons-vue";
onMounted(() => {
  window.googlAdsense();
  tableList.value = []
  getList()
})
const  searchText = ref(null)
const queryParam = ref({
  page: 1,
  limit: 24,
  name: '',
  keyword:''
})
const total = ref(0)
const tableList = ref([])
const getList = () => {
  demoList(queryParam.value).then(res => {
   if(res.code==200){
     tableList.value = res.result.records
     total.value = res.result.total
   }else{
     ElMessage.error(res.msg)
   }
  })
}
const footerFlag = ref(false)

const skipInfo = (i)=>{
  router.push('/info?ids=' + i.id)
}
const loadMore = () => {
 if(total.value > tableList.value.length){
   queryParam.value.page +=1
   getList()
 }

}

const clickSearch = (data) =>{
  queryParam.value.name = data
  queryParam.value.page =1
  tableList.value = []
  getList()
}
const handleCurrentChange = (data)=>{
  console.log(data,'dd')
  queryParam.value.page = data
  getList()
}

const font = reactive({
  color: 'rgba(0, 0, 0, .15)',
})


</script>

<template>
<!--  <el-watermark :font="font" content="微信号：x1105064870">-->
    <!-- 导航栏 -->
    <mynav @clickSearch="clickSearch"></mynav>
  <!-- 搜索区域 -->
  <section class="search-section">
    <h2>寻找优质开源项目</h2>
    <p class="subtitle">超过10000+开源项目供您选择</p>
    <div class="search-container">
      <el-input
          v-model="queryParam.keyword"
          style="width: 240px; height: 37px; border-radius: 6px;"
          placeholder="请输入"
          :prefix-icon="Search"
      />

      <button type="submit" class="search-btn" @click="getList">搜索</button>
    </div>
  </section>

    <div style="  background-color: rgb(245, 247, 250);
    color: rgb(51, 51, 51);" class="bodys">
<!--      <mynav :isShow="true" @clickSearch="clickSearch"></mynav>-->

      <div class="banner"  v-if="false" >
<!--        <div style="margin-right: 20px;text-align: center;position: fixed;left: 6%;top: 20%">-->
<!--          <div class="smfont">微信加好友</div>-->
<!--          <div>-->
<!--            <img style="width: 200px;height: 200px;" src="@/assets/img.png" alt="">-->
<!--          </div>-->
<!--        </div>-->
        <!-- 资源分类 -->

        <div class="contant" style="overflow: auto;height: 80vh;"  v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <div class="item" v-for="i in tableList" :key="i" @click="skipInfo(i)">
            <img style="width: 150px;height: 150px;" v-if="i.titleImage" :src="'/api/public/download?path='+i.titleImage" alt="">
<!--            <img style="width: 80%;height: 150px;margin-top: 10px;" v-else src="@/image/OIP.jpeg" alt="">-->
            <div class="detail">
              <div>{{i.title}}</div>
            </div>
            <div style="display: flex;flex-wrap: wrap;margin-top: 5px">
              <el-tag style="margin-right: 5px" v-for="(j,indexs) in i.demoTags" :key="indexs" type="primary">{{j.tagName}}</el-tag>
            </div>
          </div>

          <el-backtop :right="100" :bottom="100" />
        </div>
<!--        <div style="margin-left: 20px;text-align: center;position: fixed;right: 5%;top: 20%">-->
<!--          <div class="smfont">定制扫码</div>-->
<!--          <div>-->
<!--            <img style="width: 200px;height: 200px;" src="@/assets/img_1.png" alt="">-->
<!--          </div>-->

<!--          <div>-->
<!--            &lt;!&ndash; 侧边栏广告 &ndash;&gt;-->
<!--            <ins class="adsbygoogle googlAdsense"-->
<!--                 style="display:block;"-->
<!--                 data-ad-client="ca-pub-1953073280882756"-->
<!--                 data-ad-slot="4039475484"-->
<!--                 data-ad-format="auto"-->
<!--                 data-full-width-responsive="true"></ins>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <section class="categories">
        <h2>热门分类</h2>
        <div class="category-grid" @click="router.push('/category-detail')">
          <div class="category-card">
            <img src="@/image/web.png" alt="Web开发">
            <h3>Web开发</h3>
            <p>React, Vue, Angular等</p>
          </div>
          <div class="category-card">
            <img src="@/image/mobile.png" alt="移动开发">
            <h3>移动开发</h3>
            <p>Android, iOS, Flutter</p>
          </div>
          <div class="category-card">
            <img src="@/image/backend.png" alt="后端开发">
            <h3>后端开发</h3>
            <p>Spring, Django, Node.js</p>
          </div>
          <div class="category-card">
            <img src="@/image/AI.png" alt="人工智能">
            <h3>人工智能</h3>
            <p>TensorFlow, PyTorch</p>
          </div>
        </div>
      </section>
      <section class="popular-downloads">
        <h2>热门项目</h2>
        <div class="download-list" >
          <a href="#"  class="download-item" v-for="i in tableList" :key="i" @click="skipInfo(i)">
            <div class="item-info">
              <img :src="'/api/public/download?path='+i.titleImage" alt="Vue.js 项目模板" class="project-main-image">
              <div class="project-header">
                <h3>{{i.title}}</h3>
                <span class="language-tag" v-for="(j,indexs) in i.demoTags">{{j.tagName}}</span>
              </div>
              <p class="project-desc">包含Vuex, Router的完整项目模板</p>
              <div class="project-meta">
                <span><img src="@/image/star.png" style="width: 14px;height: 14px;" alt=""> 1.2k</span>
                <span> <img src="@/image/code-branch.png" style="width: 14px;height: 14px;" alt="">234</span>
                <span><img src="@/image/download.png" style="width: 14px;height: 14px;" alt=""> 5.6k</span>
              </div>
            </div>
            <button class="download-btn">查看详情</button>
          </a>


        </div>
        <div style="display: flex;justify-content: center;margin-top: 20px" >
          <el-pagination :current-page="queryParam.page" @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total" />
        </div>
        <el-backtop :right="100" :bottom="100" />
      </section>
    </div>


    <myfoot></myfoot>
<!--  </el-watermark>-->

</template>

<style scoped>

.smfont{
  margin: 10px 0;font-size: 16px;font-weight: bold;
}

.banner{
  width: 1280px;
  height: 100%;
  display: flex;justify-content: center;
  margin: calc(30px) auto 0;

}
.contant{
  width: 100%;
  height: 100%;
  overflow: scroll;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap:8px;
  text-align: center;
}
.item{
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
  height: 250px;
}
.item:hover {
  animation: shadow-animation 0.5s forwards;
}

@keyframes shadow-animation {
  0% {
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
}
.detail{
  width: 100%;
  margin-top: 30px;
  font-size: 16px;
}



@media (max-width: 768px) {
  .contant {
    grid-template-columns: repeat(1,1fr);
  }
}

/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {

}

/* 添加新的变量 */
:root {
  --primary-color: #7C4DFF;  /* 更鲜艳的紫色 */
  --secondary-color: #00E5FF; /* 亮青色 */
  --dark-color: #2B2D42;
  --light-color: #F8F9FA;
  --accent-color: #FF4081; /* 粉色强调色 */
  --gradient-start: #7C4DFF;
  --gradient-end: #00E5FF;
  --code-font: 'Fira Code', monospace;
}

/* 资源分类样式 */
.categories {
  padding: 4rem 5%;
}

.categories h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.category-card {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.category-card:hover {
  border-color: #7C4DFF;
  transform: translateY(-8px);
  box-shadow: 0 10px 20px rgba(124, 77, 255, 0.15);
}

.category-card img {
  width: 64px;
  height: 64px;
  margin-bottom: 1rem;
  animation: float 3s ease-in-out infinite;
}

.category-card h3 {
  color: #2c3e50;
}

.category-card p {
  color: #666;
  margin-top: 0.5rem;
}

.category-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 5px;
  right: 5px;
  height: 4px;
  background: #7C4DFF;
  transform: scaleX(0);
  transition: transform 0.3s;
}

.category-card:hover::before {
  transform: scaleX(1);
}

/* 修改项目卡片样式 */
.download-item {
  text-decoration: none;
  color: inherit;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid #eee;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
}

.download-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(124, 77, 255, 0.12);
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.project-header h3 {
  margin: 0;
  color: var(--dark-color);
  font-size: 1.2rem;
}

.language-tag {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  color: white;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.project-desc {
  color: #666;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.project-meta {
  display: flex;
  gap: 1.5rem;
  padding: 0.8rem 0;
  border-top: 1px solid #eee;
  margin-top: auto;
}

.project-meta span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.project-meta span i {
  color: var(--primary-color);
}

.download-btn {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(124, 77, 255, 0.3);
}

/* 项目网格布局 */
.download-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  padding: 0 1rem;
}

/* 确保卡片内容布局正确 */
.item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

/* 添加代码片段样式 */
.code-preview {
  background-color: #1e1e1e;
  border-radius: 5px;
  padding: 1rem;
  font-family: var(--code-font);
  color: #e6e6e6;
  margin: 1rem 0;
}

/* 页脚样式 */
footer {
  background-color: #2c3e50;
  color: white;
  padding: 4rem 5% 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section h4 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.social-links a {
  color: white;
  text-decoration: none;
  margin-right: 1rem;
}

.social-links a:hover {
  color: #3498db;
}

.copyright {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* 添加动画效果 */
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
}

/* 添加响应式优化 */
@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    text-align: center;
  }

  .nav-links {
    margin-top: 1rem;
  }

  .nav-links a {
    margin: 0 1rem;
  }

  .search-container {
    flex-direction: column;
  }

  .search-container button {
    width: 100%;
  }

  .search-section h2 {
    font-size: 2.2rem;
  }

  .search-container {
    gap: 0.8rem;
  }

  .language-select {
    width: 100%;
  }

  .project-meta {
    flex-wrap: wrap;
  }

  .download-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

/* 项目主图样式 */
.project-main-image {
  width: 100%; /* 使主图占满卡片宽度 */
  height: auto; /* 保持图片比例 */
  border-radius: 8px; /* 圆角效果 */
  margin-bottom: 1rem; /* 与其他内容的间距 */
}

/* 热门下载样式 */
.popular-downloads {
  padding: 4rem 5%;
  border-radius: 16px; /* 圆角效果 */

}

.popular-downloads h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
}

/* 项目网格布局 */
.download-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); /* 每个项目卡片的最小宽度 */
  gap: 16px; /* 项目之间的间距 */
  padding: 0 1rem;
}
/* 响应式设计 */
@media (max-width: 1200px) {
  .download-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); /* 在较大屏幕上每个网格项至少 250px 宽 */
  }
}

@media (max-width: 968px) {
  .download-list {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* 在较小屏幕上每个网格项至少 200px 宽 */
  }
}

@media (max-width: 768px) {
  .download-list {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); /* 在更小屏幕上每个网格项至少 150px 宽 */
  }
}

@media (max-width: 576px) {
  .download-list {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); /* 在最小屏幕上每个网格项至少 100px 宽 */
  }
}

/* 项目卡片样式 */
.download-item {
  text-decoration: none;
  color: inherit;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid #eee;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
}

.download-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(124, 77, 255, 0.12);
}

.item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.project-header h3 {
  margin: 0;
  color: var(--dark-color);
  font-size: 1.2rem;
}

.language-tag {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  color: white;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.project-desc {
  color: #666;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.project-meta {
  display: flex;
  gap: 1.5rem;
  padding: 0.8rem 0;
  border-top: 1px solid #eee;
  margin-top: auto;
}

.project-meta span {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.project-meta span i {
  color: #7C4DFF;
}

.download-btn {
  background: linear-gradient(135deg,  #7C4DFF, #00E5FF);
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  margin-top: 1rem;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(124, 77, 255, 0.3);
}


/* 修改搜索区域样式 */
.search-section {
  background: linear-gradient(135deg, #7C4DFF, #00E5FF); /* 渐变背景 */
  color: white; /* 字体颜色 */
  padding: 4rem 5%; /* 内边距 */
  border-radius: 16px; /* 圆角效果 */
  text-align: center; /* 文本居中 */
}

.search-section h2 {
  font-size: 2.5rem; /* 标题字体大小 */
  margin-bottom: 1rem; /* 标题与下方内容的间距 */
}

.search-section .subtitle {
  font-size: 1.2rem; /* 副标题字体大小 */
  margin-bottom: 2rem; /* 副标题与搜索框的间距 */
  opacity: 0.9; /* 副标题透明度 */
}

.search-container {
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  gap: 1rem; /* 元素间距 */
}

.search-input {
  padding: 1rem; /* 内边距 */
  border: none; /* 去掉边框 */
  border-radius: 8px; /* 圆角效果 */
  width: 300px; /* 输入框宽度 */
  font-size: 1rem; /* 字体大小 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.language-select {
  padding: 1rem; /* 内边距 */
  border: none; /* 去掉边框 */
  border-radius: 8px; /* 圆角效果 */
  font-size: 1rem; /* 字体大小 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}

.search-btn {
  padding: 1rem 2rem; /* 内边距 */
  border: none; /* 去掉边框 */
  border-radius: 8px; /* 圆角效果 */
  background: #FF4081; /* 按钮背景色 */
  color: white; /* 字体颜色 */
  font-size: 1rem; /* 字体大小 */
  cursor: pointer; /* 鼠标指针样式 */
  transition: background 0.3s; /* 背景色过渡效果 */
}

.search-btn:hover {
  background: #D5006D; /* 悬停时的背景色 */
}
</style>
